<template>
	<div>
		<!-- 面包屑导航区域 -->		
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div style="margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
				<el-form :model="buttonReq" label-width="70px" inline size="small">
					<el-form-item label="按钮名称">
						<el-input :clearable = true placeholder="请输入按钮名称" v-model="buttonReq.buttonName" @change="getButtonList()" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getButtonList()" style="margin-left: 8px;">查询</el-button>
					</el-form-item>
				</el-form>
				<el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增按钮</el-button>
			</div>
			<!-- 按钮权限列表区 -->
			<el-table :data="buttonList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index"></el-table-column>
				<el-table-column label="按钮名称" prop="buttonName"></el-table-column>
				<el-table-column label="按钮编码" prop="buttonCode"></el-table-column>
				<el-table-column label="创建时间" prop="createTime"></el-table-column>
				<el-table-column label="更新时间" prop="updateTime"></el-table-column>
				<el-table-column label="操作" width="200px">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="mini"
							@click="editButton(scope.row)">编辑</el-button>
						<el-button type="danger" icon="el-icon-delete" size="mini" style="margin-left: 8px;"
							@click="deleteButton(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		
		<!-- 按钮权限编辑对话框 -->
		<el-dialog title="按钮权限编辑" :visible.sync="buttonDialogVisible" width="600px">
			<el-form :model="buttonForm" status-icon ref="buttonForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="按钮名称" prop="buttonName" :rules="[{ required: true, message: '请输入按钮名称', trigger: 'blur' }]">
					<el-input v-model="buttonForm.buttonName" size="small" :clearable=true></el-input>
				</el-form-item>
				<el-form-item label="按钮编码" prop="buttonCode" :rules="[{ required: true, message: '请输入按钮编码', trigger: 'blur' }]">
					<el-input v-model="buttonForm.buttonCode" size="small" :clearable=true></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="buttonDialogVisible = false">取 消</el-button>
				<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="saveButton()">保 存</el-button>
			</span>
		</el-dialog>
		
		<!-- 按钮权限新增对话框 -->
		<el-dialog title="按钮权限新增" :visible.sync="addDialogVisible" width="600px">
			<el-form :model="addForm" status-icon ref="addForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="按钮名称" prop="buttonName" :rules="[{ required: true, message: '请输入按钮名称', trigger: 'blur' }]">
					<el-input v-model="addForm.buttonName" size="small" :clearable=true></el-input>
				</el-form-item>
				<el-form-item label="按钮编码" prop="buttonCode" :rules="[{ required: true, message: '请输入按钮编码', trigger: 'blur' }]">
					<el-input v-model="addForm.buttonCode" size="small" :clearable=true></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialogVisible = false">取 消</el-button>
				<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="saveAddButton()">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 按钮权限查询参数
			buttonReq: {
				buttonName: ''
			},
			// 按钮权限列表
			buttonList: [],
			// 控制按钮编辑对话框显示与隐藏
			buttonDialogVisible: false,
			// 控制按钮新增对话框显示与隐藏
			addDialogVisible: false,
			// 当前编辑的按钮信息
			buttonForm: {
				id: '',
				buttonName: '',
				buttonCode: '',
				createUser: '',
				updateUser: ''
			},
			// 新增按钮信息
			addForm: {
				buttonName: '',
				buttonCode: '',
				updateUser: ''
			}
		}
	},
	created() {
		this.getButtonList()
	},
	methods: {
		// 获取按钮权限列表
		async getButtonList() {
			const { data: res } = await this.$http.post(
				'/admin/permission/button/getButtonPermissionPageInfo',
				{
					page: 1,
					limit: 100, // 暂时使用较大的limit，后续可以添加分页功能
					buttonName: this.buttonReq.buttonName
				})
			if (res.code != 200) return this.$message.error(res.msg)
			this.buttonList = res.data.list
		},
		// 打开新增对话框
		openAddDialog() {
			this.addForm = {
				buttonName: '',
				buttonCode: '',
				updateUser: ''
			}
			this.addDialogVisible = true
		},
		// 保存新增按钮
		async saveAddButton() {
			if (!this.addForm.buttonName || !this.addForm.buttonCode) {
				this.$message.error('请填写完整信息')
				return
			}
			
			const { data: res } = await this.$http.post('/admin/permission/button/add', this.addForm)
			if (res.code != 200) return this.$message.error(res.msg)
			this.$message.success('新增成功')
			this.addDialogVisible = false
			this.getButtonList()
		},
		// 编辑按钮
		editButton(button) {
			this.buttonForm = {
				id: button.id,
				buttonName: button.buttonName,
				buttonCode: button.buttonCode,
				createUser: button.createUser,
				updateUser: button.updateUser
			}
			this.buttonDialogVisible = true
		},
		// 保存按钮
		async saveButton() {
			if (!this.buttonForm.buttonName || !this.buttonForm.buttonCode) {
				this.$message.error('请填写完整信息')
				return
			}
			
			let url = '/admin/permission/button/add'
			if (this.buttonForm.id) {
				url = '/admin/permission/button/update'
			}
			
			const { data: res } = await this.$http.post(url, this.buttonForm)
			if (res.code != 200) return this.$message.error(res.msg)
			this.$message.success(this.buttonForm.id ? '更新成功' : '新增成功')
			this.buttonDialogVisible = false
			this.getButtonList()
		},
		// 删除按钮
		deleteButton(id) {
			this.$confirm('确认删除该按钮权限吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const { data: res } = await this.$http.get(`/admin/permission/button/delete/${id}`)
				if (res.code != 200) return this.$message.error(res.msg)
				this.$message.success('删除成功')
				this.getButtonList()
			}).catch(() => {
				// 取消删除
			})
		}
	},
}
</script>

<style>
</style>
